import { Typography } from '@mui/material'
import { useNavigate } from 'react-router'
import { BreadcrumbObjectType } from '../../common/generated/apollo-operations'
import { Breadcrumb } from '../../common/utils/breadcrumbs'
import { WorkspaceIcon } from '../navigation/WorkspaceIcon'

export const RecordLink = ({ record, indents = 0 }: { record: Breadcrumb; indents?: number }) => {
  const navigate = useNavigate()
  return (
    <div
      className="group/link flex w-full cursor-pointer items-center rounded bg-gray-3 px-3 py-2 transition duration-300"
      onClick={() => navigate(record.link)}
    >
      {Array.from({ length: indents }).map((_, i) => (
        <div key={i} className="h-4 w-5" />
      ))}
      <div className="flex flex-1 items-center gap-2">
        <div className="flex size-3 items-center">
          <WorkspaceIcon size={16} workspaceType={BreadcrumbObjectType.TABLE_ROW} />
        </div>
        <div className="flex-1 overflow-hidden">
          <Typography noWrap>{record.name}</Typography>
        </div>
      </div>
    </div>
  )
}
